<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>


    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="header">
            <h2>Manage Riders</h2>
             <div class="float-right">
                <button type="button" class="btn btn-outline-primary btn-sm" (click)="triggerRiderOnboarding()">
                  <i class="fa fa-plus"></i> &nbsp;<span>Onboard New Rider</span></button>
              </div>
          </div>
          <div class="body mt-2">
            <div class="text-center mt-1 mb-3" *ngIf="loadingData"><span class="fa fa-spin fa-spinner fa-2x"></span>&nbsp; Loading, Please wait...</div>
            <div class="table-responsive">
              <table id="all-riders" class="table table-bordered table-hover table-striped dataTable" cellspacing="0" width="100%">
                <thead>
                <tr >
                  <!--<th class="no-sort"></th>-->

                  <th>#</th>
                  <th>Full Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>DOB</th>
                  <th>Gender</th>
                  <th>Nationality</th>
                  <th hidden>Marital Status</th>
                  <th hidden>State of Origin</th>
                  <th hidden>LGA of Origin</th>
                  <th hidden>Residential Address</th>
                  <th hidden>NIMC Number</th>
                  <th hidden>Enrollment Payment Status</th>
                  <th hidden>Driving Test Status</th>
                  <th hidden>Bank Name</th>

                  <th hidden>Account Number</th>
                  <th hidden>BVN</th>
                  <th hidden>Operation State</th>
                  <th hidden>Operation LGA</th>
                  <th hidden>Operation Town</th>
                  <th hidden>Operation Locality</th>
                  <th hidden>Association Name</th>
                  <th hidden>Association Address</th>
                  <th hidden>Agent Name</th>
                  <th hidden>Ride Reg Number</th>
                  <th hidden>Ride Chasis Number</th>
                  <th class="text-center">Action</th>
                </tr>
                </thead>
                <tfoot>
                <tr >
                  <!--<th class="no-sort"></th>-->

                  <th>#</th>
                  <th>Full Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>DOB</th>

                  <th>Gender</th>
                  <th>Nationality</th>
                  <th hidden>Marital Status</th>
                  <th hidden>State of Origin</th>
                  <th hidden>LGA of Origin</th>
                  <th hidden>Residential Address</th>
                  <th hidden>NIMC Number</th>
                  <th hidden>Enrollment Payment Status</th>
                  <th hidden>Driving Test Status</th>
                  <th hidden>Bank Name</th>
                  <th hidden>Account Number</th>
                  <th hidden>BVN</th>
                  <th hidden>Operation State</th>
                  <th hidden>Operation LGA</th>
                  <th hidden>Operation Town</th>
                  <th hidden>Operation Locality</th>
                  <th hidden>Association Name</th>
                  <th hidden>Association Address</th>
                  <th hidden>Agent Name</th>
                  <th hidden>Ride Reg Number</th>
                  <th hidden>Ride Chasis Number</th>
                  <th class="text-center">Action</th>
                </tr>
                </tfoot>
                <tbody>

                <tr *ngFor="let rider of allRiders;let i = index;">
                  <!--<td class="details-control" [id]="'td-' + i"></td>-->

                  <td>{{ i + 1 }}</td>
                  <td>
                    <img [src]="rider?.image ? rider.image : '../../../assets/images/user-small-2.png'" width="50" height="50"
                         class="img" style="border-radius: 50%"> &nbsp;
                    {{ rider?.full_name }}

                  </td>
                  <td>{{ rider?.email }}</td>
                  <td>{{ rider?.phone_no }}</td>
                  <td>{{ rider?.dob | date }}</td>
                  <td>{{ rider?.gender }}</td>
                  <td>{{ rider?.nationality }}</td>
                  <td hidden>{{ rider?.marital_status }}</td>
                  <td hidden>{{ rider?.state_of_origin?.name }}</td>
                  <td hidden>{{ rider?.lga_of_origin?.name }}</td>
                  <td hidden>{{ rider?.residential_address }}</td>
                  <td hidden>{{ rider?.nimc_no }}</td>
                  <td hidden>{{ rider?.enrollment_payment_status }}</td>
                  <td hidden>{{ rider?.driving_test_status }}</td>
                  <td hidden>{{ rider?.bank?.bank_name }}</td>
                  <td hidden>{{ rider?.account_no}}</td>
                  <td hidden>{{ rider?.bvn}}</td>
                  <td hidden>{{ rider?.operation_state?.name}}</td>
                  <td hidden>{{ rider?.operation_lga?.name}}</td>
                  <td hidden>{{ rider?.operation_town}}</td>
                  <td hidden>{{ rider?.operation_locality}}</td>
                  <td hidden>{{ rider?.association_name}}</td>
                  <td hidden>{{ rider?.association_address}}</td>
                  <td hidden>{{ rider?.agent?.first_name + " " +rider?.agent?.last_name}}</td>
                  <td hidden>{{ rider?.ride?.registration_number}}</td>
                  <td hidden>{{ rider?.ride?.chasis_number}}</td>
                  <td class="text-center">
                    <div>
                      <span role="button" data-balloon="View Details" data-balloon-pos="up" (click)="viewRider(rider)">
                        <i class="fa fa-eye text-info"></i>
                      </span>

                    </div>
                  </td>
                </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>

    </div>



  </div>
</div>



<!-- View Riders Details -->
<!-- The Modal -->
<div class="modal fade" id="riderDetails">
  <div class="modal-dialog modal-lg" *ngIf="isRiderInfo">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Rider Information</h4>
        <button type="button" class="close" data-dismiss="modal"  (click)="closeInformation()">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <div class="table-responsive">
          <table class="table table-bordered table-striped table-hover">
            <tr>
              <th>First Name</th><td>{{viewThisRider?.first_name}}</td>
              <th>Last Name</th><td>{{viewThisRider?.last_name}}</td>
            </tr>

            <tr>
              <th>Email</th><td>{{viewThisRider?.email}}</td>
              <th>Phone Number</th><td>{{viewThisRider?.phone_no}}</td>
            </tr>
            <tr>
              <th>DOB</th> <td>{{viewThisRider?.dob | date}}</td>
              <th>Gender</th><td>{{viewThisRider?.gender}}</td>
            </tr>
            <tr>
              <th>Nationality</th><td>{{viewThisRider?.nationality}}</td>
              <th >Marital Status</th>
              <td >{{ viewThisRider?.marital_status }}</td>

            </tr>
            <tr>
              <th >State of Origin</th>
              <td >{{ viewThisRider?.state_of_origin?.name }}</td>
              <th >LGA of Origin</th>
              <td >{{ viewThisRider?.lga_of_origin?.name }}</td>

            </tr>

            <tr>
              <th >Residential Address</th>
              <td >{{ viewThisRider?.residential_address }}</td>
              <th >NIMC Number</th>
              <td >{{ viewThisRider?.nimc_no }}</td>

            </tr>
            <tr>
              <th >Enrollment Payment Status</th>
              <td >{{ viewThisRider?.enrollment_payment_status }}</td>
              <th >Driving Test Status</th>
              <td [ngClass]="viewThisRider.driving_test_status === 'Fail' ? 'text-danger': 'text-success'">{{ viewThisRider?.driving_test_status }}</td>

            </tr>

            <tr>
              <th >Bank Name</th>
              <td >{{ viewThisRider?.bank?.bank_name }}</td>
              <th >Account Number</th>
              <td >{{ viewThisRider?.account_no}}</td>

            </tr>
            <tr>
              <th >BVN</th>
              <td >{{ viewThisRider?.bvn}}</td>
              <th >Operation State</th>
              <td >{{ viewThisRider?.operation_state?.name}}</td>
            </tr>
            <tr>
              <th >Operation LGA</th>
              <td >{{ viewThisRider?.operation_lga?.name}}</td>
              <th >Operation Town</th>
              <td >{{ viewThisRider?.operation_town}}</td>

            </tr>
            <tr>
              <th >Operation Locality</th>
              <td >{{ viewThisRider?.operation_locality}}</td>
              <th >Association Name</th>
              <td >{{ viewThisRider?.association_name}}</td>

            </tr>
            <tr>
              <th >Association Address</th>
              <td >{{ viewThisRider?.association_address}}</td>
              <th >Agent Name</th>
              <td >{{ viewThisRider?.agent?.first_name + " " +viewThisRider?.agent?.last_name}}</td>

            </tr>
            <tr>
              <th >Ride Reg Number</th>
              <td >{{ viewThisRider?.ride?.registration_number}}</td>
              <th >Ride Chasis Number</th>
              <td>{{ viewThisRider?.ride?.chasis_number}}</td>
            </tr>

          </table>
        </div>
      </div>

      <!-- Modal footer -->
      <!-- <div class="modal-footer" >
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeInformation()">Close</button>
      </div> -->

    </div>
  </div>
</div>
<app-modal [modalId]="'onboardRider'" [modalTitle]="'Onboard New Rider'">

  <form [formGroup]="onboardRiderForm" (ngSubmit)="onRiderOnboarding()" class="p-3">

    <div class="row g-3">

      <!-- First Name -->
      <div class="col-md-6">
        <label for="fname" class="mb-2 fw-bold">First Name</label>
        <input
          class="form-control"
          type="text"
          id="fname"
          formControlName="first_name"
          placeholder="First Name">
      </div>

      <!-- Last Name -->
      <div class="col-md-6">
        <label for="lname" class="mb-2 fw-bold">Last Name</label>
        <input
          class="form-control"
          type="text"
          id="lname"
          formControlName="last_name"
          placeholder="Last Name">
      </div>

      <!-- Email -->
      <div class="col-md-6">
        <label for="email" class="mb-2 fw-bold">Email</label>
        <input
          class="form-control"
          type="email"
          id="email"
          formControlName="email"
          placeholder="Email">
      </div>

      <!-- Phone -->
      <div class="col-md-6">
        <label for="phone" class="mb-2 fw-bold">Contact</label>
        <input
          class="form-control"
          type="text"
          id="phone"
          formControlName="phone_no"
          placeholder="Phone Number">
      </div>

      <!-- Date of Birth -->
      <div class="col-md-6">
        <label for="dob" class="mb-2 fw-bold">Date of Birth</label>
        <input
          class="form-control"
          type="date"
          id="dob"
          formControlName="dob">
      </div>

      <!-- Gender -->
      <div class="col-md-6">
        <label for="gender" class="mb-2 fw-bold">Gender</label>
        <select
          id="gender"
          class="form-control"
          formControlName="gender">
          <option value="">Select Gender</option>
          <option *ngFor="let g of genders" [value]="g.value">
            {{ g.name }}
          </option>
        </select>
      </div>

      <!-- State -->
      <div class="col-md-6">
        <label for="state" class="mb-2 fw-bold">State of Origin</label>
        <select
          id="state"
          class="form-control"
          formControlName="state_of_origin_id">
          <option value="">Select State</option>
          <option *ngFor="let s of states" [value]="s.id">
            {{ s.name }}
          </option>
        </select>
      </div>

      <!-- Marital Status -->
      <div class="col-md-6">
        <label for="marital" class="mb-2 fw-bold">Marital Status</label>
        <select
          id="marital"
          class="form-control"
          formControlName="marital_status">
          <option value="">Select Status</option>
          <option *ngFor="let m of maritalStatus" [value]="m.value">
            {{ m.name }}
          </option>
        </select>
      </div>

      <!-- LGA -->
      <div class="col-md-6">
        <label for="lga" class="mb-2 fw-bold">Local Government</label>
        <select
          id="lga"
          class="form-control"
          formControlName="lga_of_origin_id">
          <option value="">Select Local Government</option>
          <option *ngFor="let l of localGvts" [value]="l.lga_id">
            {{ l.name }}
          </option>
        </select>
      </div>

      <!-- Address -->
      <div class="col-md-6">
        <label for="address" class="mb-2 fw-bold">Residential Address</label>
        <input
          id="address"
          type="text"
          class="form-control"
          formControlName="residential_address"
          placeholder="Residential Address">
      </div>

    </div>

    <div class="modal-footer mt-4 d-flex justify-content-end gap-2">

      <button
        type="button"
        class="btn btn-outline-danger"
        data-dismiss="modal">
        Cancel
      </button>

      <button
        type="submit"
        *ngIf="!submitting"
        [disabled]="onboardRiderForm.invalid"
        class="btn btn-primary px-4">
        <i class="fa fa-user-plus me-2"></i>
        Add Rider
      </button>

      <span *ngIf="submitting" class="btn btn-primary px-4">
        Loading&nbsp;
        <i class="fa fa-spin fa-spinner"></i>
      </span>

    </div>

  </form>

</app-modal>
